import axios from 'axios'
import envConfig from '../config/env'

// 获取本地存储的token
function getItem(key) {
  return localStorage.getItem(key) || '';
}

// 自定义错误类
class AppServerError extends Error {
  constructor(code, message) {
    super(message);
    this.code = code;
    this.name = 'AppServerError';
  }
}

export class AdminApi {
    constructor() {
        // 在开发环境中优先使用环境配置，生产环境使用window.APP_CONFIG
        if (process.env.NODE_ENV === 'development') {
            this.ApiUrl = envConfig.apiUrl || window.APP_CONFIG?.apiUrl;
            console.log('开发环境API地址:', this.ApiUrl);
        } else {
            this.ApiUrl = window.APP_CONFIG?.apiUrl || envConfig.apiUrl;
        }
    }

    // 获取管理员仪表盘数据
    getDashboardData() {
      console.log('调用仪表盘接口')
      return this._get('/app/v1/statistics/dashboard')
        .then(response => {
          console.log('仪表盘接口返回:', response)
          return response
        })
        .catch(error => {
          console.error('仪表盘接口错误:', error)
          throw error
        })
    }

    adminLogin(params) {
        return this._post('/app/v1/admin/login', params, false, false, false)
    }

    adminUpdatePassword(params) {
      return this._post('/app/v1/admin/updatePassword', params)
    }

    customerLogin(params) {
      return this._post('/app/v1/customer/login', params, false, false, false)
    }

    // 获取客户个人信息
    getCustomerInfo() {
      return this._get('/app/v1/customer/getCustomerInfo')
    }

    // 客户修改密码
    customerUpdatePassword(params) {
      return this._post('/app/v1/customer/updatePassword', params)
    }

    merchantLogin(params) {
      return this._post('/app/v1/merchant/login', params, false, false, false)
    }

    merchantUpdatePassword(params) {
      return this._post('/app/v1/merchant/updatePassword', params)
    }

    getCustomerListByPage(params) {
      return this._get('/app/v1/customer/page', params, true)
    }

    getCustomerList() {
      return this._get('/app/v1/customer/list')
    }

    createCustomer(data) {
      return this._post('/app/v1/customer/add', data)
    }

    updateCustomer(data) {
      return this._post('/app/v1/customer/edit', data)
    }

    resetCustomerPassword(id) {
      return this._post('/app/v1/customer/resetPassword?id=' + id)
    }

    getMerchantListByPage(params) {
      return this._get('/app/v1/merchant/page', params, true)
    }

    getMerchantList() {
      return this._get('/app/v1/merchant/list')
    }

    createMerchant(data) {
      return this._post('/app/v1/merchant/add', data)
    }

    updateMerchant(data) {
      return this._post('/app/v1/merchant/edit', data)
    }

    resetMerchantPassword(id) {
      return this._post('/app/v1/merchant/resetPassword?id=' + id)
    }

    getDeviceListByPage(params) {
      return this._get('/app/v1/device/page', params, true)
    }

    addDevice(data) {
      return this._post('/app/v1/device/add', data)
    }

    updateDevice(data) {
      return this._post('/app/v1/device/edit', data)
    }

    getOrderStatusLog (id) {
      return this._get('/app/v1/order/statusLog', { id })
    }

    // 获取订单可能的下一步骤
    getOrderNextSteps(id) {
      return this._get('/app/v1/order/nextSteps', { id })
    }
    
    // 更新订单进度到指定状态
    updateOrderStep(data) {
      return this._post('/app/v1/order/updateStep', data)
    }

    createOrder(data) {
      return this._post('/app/v1/order/createOrder', data)
    }

    getOrderListByPage(params) {
      return this._get('/app/v1/order/page', params, true)
    }

    getOrderById(id) {
      return this._get('/app/v1/order/getById', { id })
    }

    editOrder(data) {
      return this._post('/app/v1/order/editOrder', data)
    }

    updateOrderStatus(data) {
      return this._post('/app/v1/order/updateStatus', data)
    }

    // 回寄样品
    returnSample(data) {
      return this._post('/app/v1/order/returnSample', data)
    }

    // 申请转寄样品
    applyForward(data) {
      return this._post('/app/v1/order/applyForward', data)
    }
    
    // 转寄样品
    forwardSample(data) {
      return this._post('/app/v1/order/forwardSample', data)
    }

    // 提交争议/复测信息
    submitDispute(data) {
      return this._post('/app/v1/order/submitDispute', data)
    }
    
    // 处理复测申请
    processRetestApplication(data) {
      return this._post('/app/v1/order/processRetest', data)
    }

    // 获取对比测试结果数据
    getCompareTestResult(params) {
      return this._get('/app/v1/order/getCompareTestResult', params)
    }

    // 提交对比测试结果
    submitCompareResult(data) {
      return this._post('/app/v1/order/submitCompareResult', data)
    }

    uploadContractAndInvoice(data) {
      return this._post('/app/v1/order/uploadContractAndInvoice', data)
    }

    uploadReports(data) {
      return this._post('/app/v1/order/uploadReports', data)
    }

    // 文件上传接口
    uploadFile(file, customerId = '', onProgress = null) {
      const formData = new FormData();
      formData.append('file', file);
      if (customerId) {
        formData.append('customerId', customerId);
      }
      
      return this._upload('/app/v1/file/upload', formData, onProgress);
    }
    
    // 下载文件 - 用于二进制文件流下载
    downloadFile(params = {}) {
      return axios({
        url: this.ApiUrl + '/app/v1/file/download',
        method: 'GET',
        params: params,
        responseType: 'blob',
        headers: {
          'token': getItem('token'),
          'Accept': 'application/octet-stream'
        }
      });
    }
    
    // 从OSS下载文件 - 用于二进制文件流下载
    downloadOssFile(date, fileName) {
      return axios({
        url: this.ApiUrl + `/app/v1/file/oss/download/${date}/${fileName}`,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'token': getItem('token'),
          'Accept': 'application/octet-stream'
        }
      });
    }
    
    // 预览OSS文件 - 直接在浏览器中打开预览
    previewOssFile(date, fileName) {
      console.log('调用previewOssFile方法，参数:', date, fileName);
      
      const token = getItem('token');
      
      // 构建URL
      const previewUrl = this.ApiUrl + `/app/v1/file/oss/preview/${date}/${fileName}`;
      
      // 创建一个带token的URL
      const tokenParam = encodeURIComponent(token);
      const finalUrl = `${previewUrl}?token=${tokenParam}`;
      
      // 直接在新窗口打开URL
      window.open(finalUrl);
      
      // 返回一个成功的Promise
      return Promise.resolve(true);
    }
    
    // 获取OSS文件信息
    getOssFileInfo(filePath) {
      return this._get('/app/v1/file/oss/info', { filePath });
    }
    
    // 删除OSS文件
    deleteOssFile(filePath) {
      return this._get('/app/v1/file/oss/delete', { filePath });
    }
    
    // 批量上传文件
    uploadFiles(files, customerId = '', onProgress = null) {
      const formData = new FormData();
      files.forEach((file, index) => {
        formData.append('files', file);
      });
      if (customerId) {
        formData.append('customerId', customerId);
      }
      
      return this._upload('/app/v1/file/batchUpload', formData, onProgress);
    }

    // 物流公司相关接口
    getLogisticsListByPage(params) {
      return this._get('/app/v1/logistics/page', params, true)
    }

    getLogisticsList() {
      return this._get('/app/v1/logistics/list')
    }

    createLogistics(data) {
      return this._post('/app/v1/logistics/add', data)
    }

    updateLogistics(data) {
      return this._post('/app/v1/logistics/edit', data)
    }

    deleteLogistics(id) {
      return this._post('/app/v1/logistics/delete', { id })
    }

    // 系统配置相关接口
    getAllSysConfigs() {
      return this._get('/app/v1/sysConfig/list')
    }

    getSysConfigsByType(configType) {
      return this._get(`/app/v1/sysConfig/type/${configType}`)
    }

    getConfigValue(configKey) {
      return this._get(`/app/v1/sysConfig/value/${configKey}`)
    }

    updateSysConfig(data) {
      return this._put('/app/v1/sysConfig/update', data)
    }

    batchUpdateSysConfig(data) {
      return this._put('/app/v1/sysConfig/batchUpdate', data)
    }

    refreshSysConfigCache() {
      return this._get('/app/v1/sysConfig/refreshCache')
    }

    getOrderConfig() {
      return this._get('/app/v1/sysConfig/orderConfig')
    }

    getMerchantInfo() {
      return this._get('/app/v1/merchant/getMerchantInfo')
    }

    getMerchantDashboardData() {
      return this._get('/app/v1/statistics/merchantDashboard')
    }

    // 直接访问OSS文件（使用token验证方式）
    directAccessOssFile(url) {
      // 为URL添加token认证参数
      const token = getItem('token');
      const separator = url.includes('?') ? '&' : '?';
      const authorizedUrl = `${url}${separator}token=${encodeURIComponent(token)}`;
      
      return axios({
        url: authorizedUrl,
        method: 'GET',
        responseType: 'blob'
      });
    }
    
    // 通过服务端代理访问OSS文件（解决防盗链问题）
    proxyOssFile(url) {
      return axios({
        url: this.ApiUrl + '/app/v1/file/oss/proxy',
        method: 'GET',
        params: { url },
        responseType: 'blob',
        headers: {
          'token': getItem('token')
        }
      });
    }

    // 判断文件是否为OSS文件
    isOssFile(file) {
      if (!file) return false;
      
      // 检查文件对象的特征来判断是否为OSS文件
      return (
        file.isOss || 
        (file.url && file.url.includes('oss-cn-hangzhou')) || 
        (file.path && file.path.includes('/')) ||
        (file.filePath && (file.filePath.includes('/') || file.filePath.includes('oss')))
      );
    }
    
    // 获取OSS文件预览URL
    getPreviewUrl(file) {
      if (!file) return null;
      
      try {
        // 从文件路径提取日期和文件名
        let date, fileName;
        
        console.log('尝试解析文件信息:', file);
        
        if (file.filePath) {
          const parts = file.filePath.split('/');
          if (parts.length >= 2) {
            // 假设路径格式为: 2024-05-12/filename.jpg
            date = parts[0];
            fileName = parts[1];
            console.log('从filePath提取到日期和文件名:', date, fileName);
          }
        } else if (file.path) {
          const parts = file.path.split('/');
          if (parts.length >= 2) {
            date = parts[0];
            fileName = parts[1];
            console.log('从path提取到日期和文件名:', date, fileName);
          }
        } else if (file.url) {
          // 尝试从URL中提取日期和文件名
          const match = file.url.match(/\/([^\/]+)\/([^\/]+)$/);
          if (match && match.length >= 3) {
            date = match[1];
            fileName = match[2];
            console.log('从url提取到日期和文件名:', date, fileName);
          }
        } else if (file.name || file.fileName) {
          // 如果有name但没有路径信息，看看是否有日期信息
          if (file.date) {
            date = file.date;
            fileName = file.name || file.fileName;
            console.log('使用文件对象自带的日期和文件名:', date, fileName);
          }
        }
        
        // 如果成功提取到日期和文件名，构建预览URL
        if (date && fileName) {
          const previewUrl = `${this.ApiUrl}/app/v1/file/oss/preview/${date}/${fileName}`;
          console.log('生成预览URL:', previewUrl);
          return previewUrl;
        }
        
        console.warn('无法从文件对象中提取日期和文件名');
        return null;
      } catch (error) {
        console.error('获取预览URL失败', error);
        return null;
      }
    }

    // 预览OSS文件（直接调用API获取文件并打开）
    openOssFilePreview(file) {
      try {
        // 检查文件类型是否支持直接预览
        const fileNameStr = (file.name || file.fileName || '').toLowerCase();
        const supportPreview = ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'].some(ext => 
          fileNameStr.endsWith(ext)
        );
        
        if (!supportPreview) {
          // 如果不支持预览，提示并尝试直接下载
          console.log('文件类型不支持直接预览，尝试下载', fileNameStr);
          // 尝试从路径中提取日期和文件名
          let date, downloadFileName;
          
          if (file.filePath) {
            const parts = file.filePath.split('/');
            if (parts.length >= 2) {
              date = parts[0];
              downloadFileName = parts[1];
              return this.downloadOssFile(date, downloadFileName);
            }
          } else if (file.path) {
            const parts = file.path.split('/');
            if (parts.length >= 2) {
              date = parts[0];
              downloadFileName = parts[1];
              return this.downloadOssFile(date, downloadFileName);
            }
          }
          
          // 如果没有提取到路径，直接返回错误
          return Promise.reject(new Error('无法预览该类型的文件，请使用下载功能'));
        }
        
        // 首先尝试提取日期和文件名
        let date, fileNamePath;
        
        console.log('尝试预览文件:', file);
        
        if (file.filePath) {
          const parts = file.filePath.split('/');
          if (parts.length >= 2) {
            date = parts[0];
            fileNamePath = parts[1];
          }
        } else if (file.path) {
          const parts = file.path.split('/');
          if (parts.length >= 2) {
            date = parts[0];
            fileNamePath = parts[1];
          }
        } else if (file.url) {
          const match = file.url.match(/\/([^\/]+)\/([^\/]+)$/);
          if (match && match.length >= 3) {
            date = match[1];
            fileNamePath = match[2];
          }
        } else if (file.name || file.fileName) {
          if (file.date) {
            date = file.date;
            fileNamePath = file.name || file.fileName;
          }
        }
        
        // 如果没有提取到日期和文件名，尝试其他方法
        if (!date || !fileNamePath) {
          // 尝试从文件名中提取日期
          if (file.name && file.name.includes('_')) {
            // 例如：2024-05-12_filename.jpg
            const parts = file.name.split('_');
            if (parts.length >= 2 && parts[0].match(/\d{4}-\d{2}-\d{2}/)) {
              date = parts[0];
              fileNamePath = parts.slice(1).join('_');
            }
          }
          
          // 如果仍然没有提取到，但有URL
          if (!date || !fileNamePath) {
            if (file.url) {
              // 直接在新窗口打开，添加token参数
              const token = getItem('token');
              // 检查URL是否已包含查询参数
              const separator = file.url.includes('?') ? '&' : '?';
              const urlWithToken = `${file.url}${separator}token=${encodeURIComponent(token)}`;
              window.open(urlWithToken);
              return Promise.resolve(true);
            }
            
            console.error('无法从文件中提取日期和文件名，无法预览');
            return Promise.reject(new Error('无法从文件信息中提取日期和文件名'));
          }
        }
        
        console.log('准备预览OSS文件:', date, fileNamePath);
        
        // 调用预览接口 - 现在它会直接打开URL
        return this.previewOssFile(date, fileNamePath);
      } catch (error) {
        console.error('处理OSS文件预览失败:', error);
        return Promise.reject(error);
      }
    }

    // 测试OSS预览接口的权限
    testOssPreviewPermission() {
      console.log('测试OSS预览权限');
      
      // 获取当前token
      const token = getItem('token');
      
      // 尝试不同的请求头组合
      const requests = [
        // 测试1: 基本请求头
        axios({
          url: this.ApiUrl + '/app/v1/file/oss/test',
          method: 'GET',
          headers: {
            'token': token
          }
        }),
        
        // 测试2: 添加Referer头
        axios({
          url: this.ApiUrl + '/app/v1/file/oss/test',
          method: 'GET',
          headers: {
            'token': token,
            'Referer': window.location.origin
          }
        }),
        
        // 测试3: 添加Origin头
        axios({
          url: this.ApiUrl + '/app/v1/file/oss/test',
          method: 'GET',
          headers: {
            'token': token,
            'Origin': window.location.origin
          }
        }),
        
        // 测试4: 所有头部
        axios({
          url: this.ApiUrl + '/app/v1/file/oss/test',
          method: 'GET',
          headers: {
            'token': token,
            'Referer': window.location.origin,
            'Origin': window.location.origin,
            'Accept': '*/*',
            'Cache-Control': 'no-cache'
          },
          withCredentials: true
        })
      ];
      
      // 执行所有测试并返回结果
      return Promise.all(requests.map((request, index) => {
        return request
          .then(response => ({
            testIndex: index + 1,
            success: true,
            data: response.data,
            status: response.status
          }))
          .catch(error => ({
            testIndex: index + 1,
            success: false,
            error: error.message,
            status: error.response ? error.response.status : 'unknown'
          }));
      }));
    }

    /**
   *
   * @param path
   * @param data
   * @param rawResponse
   * @param rawResponseData
   * @param noToken
   * @return {Promise<string | AxiosResponse<any>|*|T>}
   * @private
   */
  async _post(path, data = {}, rawResponse = false, rawResponseData = false, noToken = true) {
    let response;
    path = this.ApiUrl + path;
    
    let headers = {};
    if (noToken) {
      headers.token = getItem('token');
    }
    
    // 如果是URLSearchParams类型，设置Content-Type为application/x-www-form-urlencoded
    if (data instanceof URLSearchParams) {
      headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    
    response = await axios.post(path, data, {
      transformResponse: rawResponseData ? [data => data] : axios.defaults.transformResponse,
      headers: headers,
    })
    if (rawResponse) {
      return response;
    }
    if (response.data) {
      if (rawResponseData) {
        return response.data;
      }
      if (response.data.code === 200 || response.data.code === 0) {
        return response.data.data ? response.data.data : true
      } else {
        throw new AppServerError(response.data.code, response.data.message)
      }
    } else {
      throw new Error('request error, status code: ' + response.status)
    }
  }

  async _get(path, data = {}, rawResponse = false, rawResponseData = false) {
    let response;
    path = this.ApiUrl + path;
    response = await axios.get(path, {
      params: data,
      transformResponse: rawResponseData ? [data => data] : axios.defaults.transformResponse,
      headers: {
        'token': getItem('token'),
      },
    })
    if (rawResponse) {
      return response;
    }
    if (response.data) {
      if (rawResponseData) {
        return response.data;
      }
      if (response.data.code === 200 || response.data.code === 0) {
        return response.data.data ? response.data.data : true
      } else {
        throw new AppServerError(response.data.code, response.data.msg)
      }
    } else {
      throw new Error('request error, status code: ' + response.status)
    }
  }

  async _put(path, data = {}, rawResponse = false, rawResponseData = false) {
    let response;
    path = this.ApiUrl + path;
    response = await axios.put(path, data, {
      transformResponse: rawResponseData ? [data => data] : axios.defaults.transformResponse,
      headers: {
        'token': getItem('token'),
        'Content-Type': 'application/json'
      },
    })
    if (rawResponse) {
      return response;
    }
    if (response.data) {
      if (rawResponseData) {
        return response.data;
      }
      if (response.data.code === 200 || response.data.code === 0) {
        return response.data.data ? response.data.data : true
      } else {
        throw new AppServerError(response.data.code, response.data.msg)
      }
    } else {
      throw new Error('request error, status code: ' + response.status)
    }
  }

  async _upload(path, formData, onProgress = null) {
    path = this.ApiUrl + path;
    
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'token': getItem('token')
      }
    };
    
    if (onProgress && typeof onProgress === 'function') {
      config.onUploadProgress = progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percentCompleted, progressEvent);
      };
    }
    
    try {
      const response = await axios.post(path, formData, config);
      
      if (response.data) {
        if (response.data.code === 200 || response.data.code === 0) {
          return response.data.data || true;
        } else {
          throw new AppServerError(response.data.code, response.data.msg || response.data.message);
        }
      } else {
        throw new Error('上传请求错误，状态码: ' + response.status);
      }
    } catch (error) {
      console.error('文件上传失败:', error);
      throw error;
    }
  }

  async _delete(path, data = {}, rawResponse = false, rawResponseData = false) {
    try {
      const token = getItem('token');
      const headers = {
        'Content-Type': 'application/json'
      };
      
      if (token) {
        headers['Authorization'] = 'Bearer ' + token;
      }
      
      let deleteConfig = {
        method: 'DELETE',
        url: this.ApiUrl + path,
        headers
      };
      
      // 如果有数据，添加到请求体
      if (data && Object.keys(data).length > 0) {
        deleteConfig.data = data;
      }
      
      const response = await axios(deleteConfig);
      
      // 处理响应
      if (rawResponse) {
        return response;
      }
      
      if (response.status === 200) {
        const responseData = response.data;
        if (responseData.code === 0 || responseData.code === 200) {
          return rawResponseData ? responseData : responseData.data;
        } else {
          throw new AppServerError(responseData.code, responseData.msg || '服务器错误');
        }
      }
      
      throw new Error('网络请求失败');
    } catch (error) {
      console.error('DELETE请求错误:', error);
      throw error;
    }
  }

  // 统一的文件预览处理函数
  previewFile(file, messageInstance) {
    // 确保有消息提示实例
    const message = messageInstance || window.Vue?.$message || console.log;
    
    return new Promise((resolve, reject) => {
      try {
        // 检查文件对象是否有效
        if (!file) {
          message.error('文件信息不完整，无法预览');
          return reject(new Error('文件信息不完整'));
        }
        
        // 检查文件类型是否支持直接预览
        const fileName = file.name || file.fileName || '';
        const fileExtension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
        const previewableExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
        const isDirectlyPreviewable = previewableExtensions.some(ext => fileExtension.includes(ext));
        
        // 如果不是可直接预览的类型，提示用户下载
        if (!isDirectlyPreviewable) {
          message.info('该文件类型不支持直接预览，将为您下载文件');
          // 调用下载方法
          return this.downloadFileUnified(file, message)
            .then(resolve)
            .catch(reject);
        }
        
        // 判断是否为OSS文件
        const isOssFile = this.isOssFile(file);
        
        if (isOssFile) {
          // 使用专用的OSS文件预览方法
          try {
            return this.openOssFilePreview(file).then(resolve).catch(error => {
              console.error('OSS文件预览失败:', error);
              message.error('文件预览失败: ' + (error.message || '服务器错误'));
              reject(error);
            });
          } catch (error) {
            console.error('OSS文件预览失败:', error);
            message.error('文件预览失败: ' + (error.message || '服务器错误'));
            return reject(error);
          }
        }
        
        // 非OSS文件的处理逻辑
        if (file.url) {
          // 检查URL是否需要添加token
          let urlToOpen = file.url;
          
          // 检查是否需要添加token（针对需要认证的URL）
          if (urlToOpen.includes(this.ApiUrl) || urlToOpen.startsWith('/')) {
            const token = getItem('token');
            // 检查URL是否已包含查询参数
            const separator = urlToOpen.includes('?') ? '&' : '?';
            urlToOpen = `${urlToOpen}${separator}token=${encodeURIComponent(token)}`;
          }
          
          // 在新窗口打开
          window.open(urlToOpen);
          return resolve(true);
        } else {
          message.warning('无法预览该文件');
          return reject(new Error('无法预览该文件，文件URL不存在'));
        }
      } catch (error) {
        console.error('文件预览处理失败:', error);
        message.error('文件预览失败: ' + (error.message || '未知错误'));
        return reject(error);
      }
    });
  }

  // 统一的文件下载处理函数
  downloadFileUnified(file, messageInstance) {
    // 确保有消息提示实例
    const message = messageInstance || window.Vue?.$message || console.log;
    
    return new Promise((resolve, reject) => {
      try {
        // 检查文件对象是否有效
        if (!file) {
          message.error('文件信息不完整，无法下载');
          return reject(new Error('文件信息不完整'));
        }
        
        message.info('文件下载中，请稍候...');
        
        // 判断是否为OSS文件
        const isOssFile = this.isOssFile(file);
        
        if (isOssFile) {
          // 从URL或filePath中提取日期和文件名
          let date, fileName;
          
          if (file.path) {
            // 如果有path属性，直接从path中提取
            const pathParts = file.path.split('/');
            if (pathParts.length >= 2) {
              date = pathParts[0];
              fileName = pathParts[1];
            }
          } else if (file.filePath) {
            // 从filePath中提取
            const pathParts = file.filePath.split('/');
            if (pathParts.length >= 2) {
              date = pathParts[0];
              fileName = pathParts[1];
            }
          } else if (file.url) {
            // 尝试从URL中提取日期和文件名
            const urlMatch = file.url.match(/\/([^\/]+)\/([^\/]+)$/);
            if (urlMatch && urlMatch.length >= 3) {
              date = urlMatch[1];
              fileName = urlMatch[2];
            }
          }
          
          if (!date || !fileName) {
            // 无法解析路径，使用通用下载方法
            return this.downloadFileWithBlob(file, message)
              .then(resolve)
              .catch(reject);
          }
          
          // 使用OSS专用下载方法
          return this.downloadOssFile(date, fileName)
            .then(response => {
              if (response && response.data) {
                // 创建Blob对象
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                
                // 创建下载链接
                const link = document.createElement('a');
                link.href = url;
                link.download = file.name || fileName;
                
                // 触发下载
                document.body.appendChild(link);
                link.click();
                
                // 清理
                setTimeout(() => {
                  window.URL.revokeObjectURL(url);
                  document.body.removeChild(link);
                }, 100);
                
                message.success('文件下载成功');
                resolve(true);
              } else {
                message.error('OSS文件下载失败，请重试');
                // 尝试常规下载
                return this.downloadFileWithBlob(file, message)
                  .then(resolve)
                  .catch(reject);
              }
            })
            .catch(error => {
              console.error('OSS文件下载失败:', error);
              message.error('OSS文件下载失败: ' + (error.message || '服务器错误'));
              // 尝试常规下载
              return this.downloadFileWithBlob(file, message)
                .then(resolve)
                .catch(reject);
            });
        } else {
          // 普通文件下载
          return this.downloadFileWithBlob(file, message)
            .then(resolve)
            .catch(reject);
        }
      } catch (error) {
        console.error('文件下载处理失败:', error);
        message.error('文件下载失败: ' + (error.message || '未知错误'));
        return reject(error);
      }
    });
  }
  
  // 使用通用方式下载文件（内部方法）
  downloadFileWithBlob(file, messageInstance) {
    const message = messageInstance || window.Vue?.$message || console.log;
    
    return new Promise((resolve, reject) => {
      // 获取文件名和路径信息
      const fileName = file.name || file.fileName || 'download';
      const filePath = file.path || file.filePath || '';
      const fileId = file.fileId;
      
      // 通过后端API下载文件
      this.downloadFile({
        fileId: fileId,
        fileName: fileName,
        filePath: filePath
      })
      .then(response => {
        if (response && response.data) {
          // 创建Blob对象
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          
          // 创建下载链接
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          
          // 触发下载
          document.body.appendChild(link);
          link.click();
          
          // 清理
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }, 100);
          
          message.success('文件下载成功');
          resolve(true);
        } else {
          message.error('文件下载失败，请重试');
          reject(new Error('文件下载失败，返回数据为空'));
        }
      }).catch(error => {
        console.error('下载文件失败:', error);
        message.error('文件下载失败: ' + (error.message || '服务器错误'));
        reject(error);
      });
    });
  }

  // 注册码分页查询
  getRegisterCodePage(params) {
    return this._get('/api/admin/register-code/page', params, true)
  }

  // 批量生成注册码
  generateRegisterCodes(count) {
    return this._post('/api/admin/register-code/generate', { count })
  }

  // 批量删除注册码
  batchDeleteRegisterCodes(ids) {
    return this._delete('/api/admin/register-code/batch', ids)
  }

  // 删除单个注册码
  deleteRegisterCode(id) {
    return this._delete(`/api/admin/register-code/${id}`)
  }

  // 结算相关接口
  // 获取月结算表单数据
  getMonthlySettlement(params) {
    return this._get('/app/v1/settlement/monthly', {
      ...params,
      merchantId: this.merchantId // 添加当前商家的ID
    })
  }
  
  // 导出月结算表单
  exportMonthlySettlement(params) {
    return axios({
      url: this.ApiUrl + '/app/v1/settlement/export',
      method: 'GET',
      params: params,
      responseType: 'blob',
      headers: {
        'token': getItem('token')
      }
    })
  }
  
  // 确认结算
  confirmSettlement(id) {
    return this._post('/app/v1/settlement/confirm', { id })
  }
  
  // 获取结算历史记录
  getSettlementHistory(params) {
    return this._get('/app/v1/settlement/history', params)
  }
  
  // 获取商家结算详情
  getMerchantSettlementDetail(params) {
    return this._get('/app/v1/settlement/merchant/detail', params)
  }

  // 修改价格
  updateOrderPrice(data) {
    return this._post('/app/v1/order/updatePrice', data)
  }

  // 修改订单
  updateOrderInfo(data) {
    return this._post('/app/v1/order/updateOrderInfo', data)
  }

  // 删除订单
  deleteOrder(id) {
    return this._get('/app/v1/order/deleteOrder', { id })
  }

  // 客户协议管理相关接口
  getAgreementListByPage(params) {
    return this._get('/app/v1/agreement/page', params, true)
  }
  
  getAgreementById(id) {
    return this._get('/app/v1/agreement/getById', { id })
  }
  
  createAgreement(data) {
    return this._post('/app/v1/agreement/add', data)
  }
  
  updateAgreement(data) {
    return this._post('/app/v1/agreement/update', data)
  }
  
  deleteAgreement(id) {
    return this._post('/app/v1/agreement/delete', { id })
  }
}

const adminApi = new AdminApi();
export default adminApi;